import React from "react";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
import { BrandSection } from "~/common/Store/models/Brand";

interface Props {
  sections: BrandSection[];
}

const BrandSections = ({ sections }: Props) => (
  <>
    {sections.map(
      (section, index) =>
        section.type === "Row" &&
        section.features.length > 0 && (
          <div className="grid-layout" key={String(index)}>
            <div className="grid-container grid-module-large">
              {section.features.map((feature) => {
                const childType =
                  feature.categoryFeatureGroup != null &&
                  feature.categoryFeatureGroup.childCount === 1
                    ? "Product"
                    : "Products";
                return (
                  feature.type === "Category" &&
                  feature.categoryFeatureGroup != null && (
                    <div
                      data-testid="vendor-sub"
                      className="grid-module grid-children-4 grid-split vendor-sub"
                      key={feature.categoryFeatureGroup.name}
                    >
                      <span className="grid-item grid-parent">
                        <a
                          className="grid-image outline-offset-[-4px]"
                          title={feature.categoryFeatureGroup.name}
                          href={feature.categoryFeatureGroup.url}
                        >
                          <img
                            data-testid="vendor-sub-img"
                            alt=""
                            src={feature.categoryFeatureGroup.imagePath}
                          />
                        </a>
                        <span className="grid-text">
                          <a href={feature.categoryFeatureGroup.url}>
                            <h2 data-testid="vendor-sub-heading">
                              {feature.categoryFeatureGroup.name}
                            </h2>
                          </a>
                          <p data-testid="vendor-sub-description">
                            {feature.categoryFeatureGroup.description}
                          </p>
                          <div className="shopAll" data-testid="shopAll">
                            <a
                              href={feature.categoryFeatureGroup.url}
                              className="btn btn-small btn-info"
                            >
                              {`View ${childType}`}
                            </a>
                            <p
                              className="sub-text"
                              data-testid="vendor-sub-text"
                            >{`${feature.categoryFeatureGroup.childCount} ${childType}`}</p>
                          </div>
                        </span>
                      </span>
                      {feature.categoryFeatureGroup
                        .categoryFeatureGroupMembers &&
                        feature.categoryFeatureGroup.categoryFeatureGroupMembers
                          .length > 0 && (
                          <div
                            className="grid-children"
                            data-testid="vendor-sub-children"
                          >
                            {feature.categoryFeatureGroup.categoryFeatureGroupMembers.map(
                              (member) => (
                                <a
                                  href={member.url}
                                  title={member.name}
                                  className="grid-item grid-child outline-offset-[-4px]"
                                  key={member.name}
                                >
                                  <NoScriptLazyImage
                                    alt=""
                                    src={member.imagePath}
                                    className="lazyLoad b-loaded"
                                  />
                                  <span className="description">
                                    {member.name}
                                  </span>
                                </a>
                              ),
                            )}
                          </div>
                        )}
                    </div>
                  )
                );
              })}
            </div>
          </div>
        ),
    )}
  </>
);

export default BrandSections;
